import type { ImportApiRouteOverrides } from "@prequel/import-react";

// Admin-only import route overrides live here when the webapp diverges from SDK defaults.
export const importApiRoutes = {} satisfies ImportApiRouteOverrides;
